import { useCallback, useEffect, useState } from "react";
import SalaryUploadCard from "../../../components/pending-approvals/salaryUpload";
import PendingAuthService from "../../../services/approvals.service";
import { useNavigate } from "react-router";
import { Breadcrumb, Card, Empty, Tabs, Button } from "antd";
import SelectAllCard from "../../../components/pending-approvals/selectAll";
import download from "../../../assests/icons/download_icon.png";
import { AiOutlineLeft } from "react-icons/ai";
import { ReactComponent as TitleIcon } from "../../../assests/images/transfer.svg";
import { useTranslation } from "react-i18next";
import SalaryHistoryGrid from "../../../components/pending-approvals/history-grids/salaryGrid";
import SalaryHistoryList from "../../../components/pending-approvals/history-lists/salaryList";
import { ReactComponent as HomeIcon } from "../../../assests/images/home-line.svg";

export default function HistoryBulkPaymentUpload() {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const { t } = useTranslation();
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    getPendingRecords();
  }, []);

  const getPendingRecords = useCallback(async () => {
    try {
      const response = await PendingAuthService.salaryUploadGetRecords({
        listType: "A",
        module: "BULKUPLOAD",
      });
      if (response.status === 200) {
        setDataSource(response.data);
      }
    } catch (error) {}
  }, []);

  const handleDownload = useCallback(async () => {
    try {
      const reqParams = {
        listType: "A",
        module: "BULKUPLOAD",
      };
      await PendingAuthService.fileUploadDownload(reqParams);
    } catch (err) {}
  }, []);

  const handleSingleRcordDownload = useCallback(async (selected) => {
    try {
      const reqParams = {
        reqId: selected.reqId,
        module: "BULKUPLOAD",
      };
      await PendingAuthService.fileSingleUploadDownload(
        reqParams,
        selected?.file
      );
    } catch (err) {}
  }, []);

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/history")}>
              {t("navigation.history", {
                defaultValue: "History",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("navigation.bulk_upload", {
                defaultValue: "Bulk Payment Upload",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("navigation.bulk_upload", {
                defaultValue: "Bulk Payment Upload",
              })}
            </h3>
          </div>
          <div className=" col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
            {dataSource.length === 0 ? null : (
              <Button
                type="default"
                className="btn-primary"
                onClick={handleDownload}
              >
                <img
                  alt="download"
                  src={download}
                  height={20}
                  style={{ paddingRight: "15px" }}
                />
                {t("buttons.download_btn", { defaultValue: "Download" })}
              </Button>
            )}
          </div>
        </div>
      </Card>
      <Card className="application-card">
        <div className="row px-2">
          {showGridAccount === "GRID" && (
            <SalaryHistoryGrid
              dataSource={dataSource}
              handleSingleRcordDownload={handleSingleRcordDownload}
            />
          )}
          {showGridAccount === "LIST" && (
            <SalaryHistoryList
              dataSource={dataSource}
              handleSingleRcordDownload={handleSingleRcordDownload}
            />
          )}
        </div>
      </Card>
    </>
  );
}
